import { useCallback, useState } from "react";

export function useStack<T>(initialStack: T[] = []) {
  const [stack, setStack] = useState<T[]>(initialStack);

  const push = useCallback((item: T) => {
    setStack((prev) => [...prev, item]);
  }, []);

  const pop = useCallback(() => {
    setStack((prev) => prev.slice(0, -1));
  }, []);

  const top = stack.length > 0 ? stack[stack.length - 1] : null;

  return { top, push, pop } as const;
}
